class ConfigrationModel {
    constructor(model) {
        this.model = model
        this.needLogin = this._computeNeedLogin()
        this.needSignature = this._computeNeedSignature()
        this.needShowDescription = this._computeNeedShowDescription()
        this.needShowQueryList = this._computeNeedShowQueryList()
        this.needShowResult = this._computeNeedShowResult()
        this.canReSubmit = this._computeCanReSubmit() // 不会展示结果
        this.canReTest = this._computeCanReTest() // 可以重新填写
        this.assessmentArray = this._computeAssessmentArray()
        this.pollShowCaseNumber = this._computeShowCaseNumber()
    }

    _computeNeedLogin() {
        return this.model.login == 1
    }

    _computeNeedSignature() {
        return this.model.hospitalId == 1469 //广西医科大学附属第一医院
    }

    _computeNeedShowDescription() {
        return this.model.desc != ''
    }

    _computeNeedShowQueryList() {
        return this.model.assessment.length > 1
    }

    _computeNeedShowResult() {
        return this.model.shows == 1
    }

    _computeCanReSubmit() {
        return this.model.resubmit == 1
    }

    _computeCanReTest() {
        return this.model.resubmit == 0 && this.model.modify == 1
    }

    _computeShowCaseNumber() {
        return this.model?.pollShowCaseNumber == 1 ? true : false
    }

    _computeAssessmentArray() {
        const assessmentArray = []
        for (const item of this.model.assessment) {
            const assessment = {
                type: item.type,
                title: item.title,
                info: `共${item.topicNum ?? 0}问，约需${item.topicTime ?? 0}分钟`,
                isFilled: false
            }
            assessmentArray.push(assessment)
        }
        return assessmentArray
    }
}

export { ConfigrationModel }
